import type { ErrorRegistryShape } from '../common/common.error';

export const PORTFOLIO_FILE_ERROR = {
  NOT_FOUND_PORTFOLIO_FILE: { status: 404, message: 'Portfolio file not found' },
  /** 미리보기 · 내려받기 티켓이 없거나 만료 · 위조, 또는 그 세션이 끝났다 */
  UNAUTHORIZED_PORTFOLIO_FILE_TICKET: { status: 401, message: 'Portfolio file ticket is invalid' },
  /** 리포트가 하나도 없는 포트폴리오에는 파일을 올릴 곳이 없다 */
  CONFLICT_PORTFOLIO_FILE_NO_REPORT: { status: 409, message: 'Portfolio has no report' },
  /** 포트폴리오 회원은 D3 종류 파일을 올릴 수 없다(보지도 지우지도 못한다 — 그때는 NOT_FOUND_PORTFOLIO_FILE) */
  FORBIDDEN_PORTFOLIO_FILE_KIND: { status: 403, message: 'File kind is not allowed for the role' },
} as const satisfies ErrorRegistryShape;
